import { ORDER_BY_OPERATOR_ORDER_BY } from '../constants';
import { noChildren } from './common';
function acceptOrderByOperator(visitor) {
  return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function enterNode(listener) {
  listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function exitNode(listener) {
  listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
export var orderByOperator = function orderByOperator() {
  return orderByOperatorInternal();
};
export var orderByOperatorInternal = function orderByOperatorInternal() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    value: ORDER_BY_OPERATOR_ORDER_BY,
    position: position,
    accept: acceptOrderByOperator,
    enterNode: enterNode,
    exitNode: exitNode,
    getChildren: noChildren,
    parent: null
  };
};